module.exports = __webpack_public_path__ + "static/img/11.4adcefc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/16/zh/11.png
// module id = wF8D
// module chunks = 0